module.exports = __webpack_public_path__ + "static/img/storageFu4.5fe9011.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/storageFu4.png
// module id = 30jn
// module chunks = 2